/* global jQuery */
const $ = jQuery;

import './styles/index.scss'
import './scripts/woo-checkout';
import './utils/tracking';

import Glide from '@glidejs/glide'
import GlideControlDisabler from './utils/glidecontroldisabler';
import React from 'react';
import ReactDOM from 'react-dom';
import Ssm from 'simplestatemanager';
import accordion from './scripts/accordion';
import components from './components/';
import imageSlider from './scripts/image-slider';
import imageSliderExpand from './scripts/image-slider-expand';
import initSearchForm from './scripts/faq-search';
import initShowMore from './scripts/show-more';
import initStickyButton from './scripts/sticky-button';
import initToggleSearch from './scripts/toggle-search';

window.React = React;
window.ReactDOM = ReactDOM;
window.Glide = Glide;
window.GlideControlDisabler = GlideControlDisabler;
window.Ssm = Ssm;
window.Components = components;

$(document).ready(() => {
    const $button = $('.js-buy-education');
    if ($button.length) {
        $button.map((i, v) => initStickyButton(v));
    }

    const $toggleSearchBtn = $('.header__search__button');
    if ($toggleSearchBtn.length) {
        initToggleSearch($toggleSearchBtn);
        initToggleSearch($('.nav-service__search__button'));
    }

    const $imageSliders = $('.carousel__wrapper');
    if($imageSliders.length) {
        $imageSliders.map((_, el) =>
            imageSlider(el)
        );
    }


    const $imageSlidersModal = $('.carousel__wrapper--modal');
    if($imageSlidersModal.length) {
        $imageSlidersModal.map((_, el) =>
            imageSlider(el)
        );
    }

    const $expand = $('.carousel__expand');
    if($expand.length) {
        $expand.map((_, el) =>
            imageSliderExpand(el)
        );
    }

    const $accordions = $('.accordion__item__title');
    if($accordions.length) {
        $accordions.map((_, el) =>
            accordion(el)
        );
    }

    const $initShowMore = $('.js-show-more');
    if($initShowMore.length) {
        $initShowMore.map((_, el) =>
          initShowMore(el)
        );
    }

    const $initSearchForm = $('.js-faq-search');
    if($initSearchForm.length) {
      $initSearchForm.map((_, el) =>
        initSearchForm(el)
      );
  }

    const activeContainerClass = 'header__mega-container--active';
    const activeChildClass = 'header__mega-menu__children--active';
    const activeLinkClass = 'header__mega-menu__link--active';
    const isMobile = window.matchMedia("only screen and (max-width: 1023px)").matches;


    $('.header__mega-menu__link.js-toggle-children').click(function (e) {
        if (e.target.href == "#") e.preventDefault();

        if ($(this).next('.header__mega-menu__children').hasClass(activeChildClass)) {
            $('.header__mega-container').removeClass(activeContainerClass);
            $('.header__mega-menu__link--active').removeClass(activeLinkClass);
            $('.header__mega-menu__item--isactive').removeClass('header__mega-menu__item--isactive');
            $('.header__mega-menu__children').removeClass(activeChildClass);
        } else {
            hideSearch();
            $('.header__mega-container').removeClass(activeContainerClass);
            $('.header__mega-menu__link--active').removeClass(activeLinkClass);
            $('.header__mega-menu__children').removeClass(activeChildClass);

            $('.header__mega-container').addClass(activeContainerClass);
            $(this).addClass(activeLinkClass);
            $(this).parent().addClass('header__mega-menu__item--isactive');
            $(this).next('.header__mega-menu__children:first').addClass(activeChildClass);
            $('ul.header__mega-menu__children--active:first').css('padding-left', $('.header__mega-menu').offset().left);
           // $('ul.header__mega-menu__children--active ul.header__mega-menu__children--active').css('padding-left', 0);
        }
    })

    function hideSearch() {
        $('.nav-service__container').removeClass('activesearch');
        $('.header__search__button').removeClass('active');
        $('.nav-service__search__button').removeClass('active');
        $('.header__search-foldout').removeClass('header__search-foldout--is-open');
        $('#search').blur();
    }

    window.onclick = function(event) {
        if (!event.target.classList.contains('js-dropdown')) {
            var dropdown = $(".dropdown-menu__list");
            if (dropdown.hasClass('dropdown-menu__list--active')) {
                dropdown.removeClass('dropdown-menu__list--active');
            }
        }

        if (!event.target.classList.contains('js-toggle-children') && !event.target.classList.contains('header__mega-menu__title')  && !event.target.classList.contains('sr-only')) {

            var dropdown = $('.header__mega-menu__children');
            $('.header__mega-menu__link').removeClass('header__mega-menu__link--active');
            $('.header__mega-container').removeClass('header__mega-container--active');
            $('.header__mega-menu__item--isactive').removeClass('header__mega-menu__item--isactive');
            if (dropdown.hasClass('header__mega-menu__children--active')) {
                dropdown.removeClass('header__mega-menu__children--active');
            }
        }
    };

    if($('.slick-slider') && $('.slick-slider')[0]){
        $(window).resize(function(){
            $('.slick-slider')[0].slick.refresh();
        });
    }

    $('.carousel__close').click(function () {
        $('.text-imagegallery--modal').removeClass('text-imagegallery--modal');
        $('body').removeClass('noscroll');
        $('html').removeClass('noscroll');
        $(this).parent().find('.slick-slider')[0].slick.refresh();
        if($(this).parent().find('.slick-slider')[1]) $(this).parent().find('.slick-slider')[1].slick.refresh();
    });

    $('.carousel__background').click(function () {
        $('.text-imagegallery--modal').removeClass('text-imagegallery--modal');
        $('body').removeClass('noscroll');
        $('html').removeClass('noscroll');
        $(this).parent().find('.slick-slider')[0].slick.refresh();
        if($(this).parent().find('.slick-slider')[1]) $(this).parent().find('.slick-slider')[1].slick.refresh();
    });


    var headerInitialHeight = $('.header').outerHeight();

    //front page (new template)
    if ($('body').hasClass('page-template-template-portal-page-new')) {
        $(window).scroll(function () {
            var headerHeight = $('.header').outerHeight();

            if (jQuery(window).scrollTop() > 500) {
                $('.header').addClass('header--sticky');
                $('.header').css('margin-top', -headerHeight);
                $('body').css('margin-top', headerInitialHeight);
            } else {
                $('.header').removeClass('header--sticky');
                $('.header').css('margin-top', 0);
                $('body').css('margin-top', 0);
            }

            if ($(window).scrollTop() > 500) {
                $('.header').addClass('header--slide-down');
            } else {
                $('.header').removeClass('header--slide-down');
            }
        })
    } else {
        $('.header').addClass('header--sticky');

        $(window).resize(function () {
            $('body').css('margin-top', $('.header').outerHeight())
        });

        $(window).resize();
    }

    $(".js-scroll-to").click(function(e) {
        e.preventDefault();
        var target = $(this).attr("href");
        $("html, body").animate({
            scrollTop: $(target).offset().top - "60"
    }, 1100);
    });

    $(".js-dropdown").click(function(e) {
        e.preventDefault();
        $(".dropdown-menu__list").toggleClass("dropdown-menu__list--active");
     });

});
